import { jsx } from 'react/jsx-runtime';
import s from './InputError.module.scss.js';
import clsx from 'clsx';

function InputError(_ref) {
  let {
    fieldState,
    errorMessage,
    className: classNameProps
  } = _ref;
  var _a;
  if (!errorMessage && !(fieldState === null || fieldState === void 0 ? void 0 : fieldState.error)) {
    return null;
  }
  const className = clsx(s.errorMessage, classNameProps);
  return jsx("small", {
    className: className,
    children: errorMessage || ((_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.error) === null || _a === void 0 ? void 0 : _a.message)
  });
}

export { InputError };
